<template>
  <div class="l_stamp_history">
    <div class="container">
      <div class="content">
        <div
          class="rankingmsg"
          :class="{ up: this.rankUp }"
          v-if="this.rankMsg"
          v-html="this.rankMsg"
        ></div>
        <div class="summary">
          <div class="item">
            <div class="title">
              <img
                :src="require('@/assets/img/stampHistory/RIREKI_RANKMARK.png')"
              />
              <div v-if="mounted">
                {{ dataFormatYyyyMm(lastMonth.month)
                }}<br
                  v-if="dataFormatYyyyMm(lastMonth.month) !== ''"
                />月間ランキング
              </div>
            </div>
            <span class="result"
              ><span class="strong">{{
                lastMonth.ranking.toLocaleString()
              }}</span>
              位</span
            >
          </div>
          <div class="caption">
            ※月間ランキングは、対象月の直近2ヶ月のスタンプ数を元にランキングしています。<br />
            ※スタンプカードリセット時に引き継がれたスタンプは、累計獲得スタンプ数、月間ランキングにはカウントされません。実際に獲得した月分のみカウントされます。
          </div>
          <div class="item">
            <div class="title">
              <img
                :src="require('@/assets/img/stampHistory/RIREKI_STAMPMARK.png')"
              />
              <div v-if="mounted">累計獲得<br />スタンプ数</div>
            </div>
            <span class="result"
              ><span class="strong">{{ stamp_total.toLocaleString() }}</span>
              個</span
            >
          </div>
          <div class="caption right">
            期間 : {{ dataFormat(user_create_at) }}〜{{ dataFormat(Date()) }}
          </div>
          <div class="link" v-if="this.rankings.length > 0">
            <router-link to="/stamphistory/monthly" class="flex-justify-center" @click.native="() => { trapTrackEvent(1) }">
              これまでの月間ランキング
              <font-awesome-icon icon="chevron-right" />
            </router-link>
          </div>
        </div>
        <template v-if="pastHistories.length > 0">
          <h2>これまでの年間ランク</h2>
          <div class=" ranks">
            <div
              v-for="(history, idx) in pastHistories"
              :key="history.stamp_data.from"
              class="rank"
            >
              <div class="header">
                {{ dataFormat(history.stamp_data.from) }} 〜
                {{ dataFormat(history.stamp_data.to) }}
              </div>
              <div class="body">
                <StampHistoryTitle :stampData="history.stamp_data" />
                <div class="button">
                  <UIButton label="スタンプを見る" @click="watchStamps(idx)" />
                </div>
              </div>
            </div>
            <div class="caption">
              ※新会員ランク制度開始前のスタンプ数は、年間ランクとして表示されません。累計スタンプ数には、新会員ランク制度開始前のスタンプ数もカウントされています
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

import DateFormatter from '../utils/DateFormatter.js'
import {
  sumStampCount,
  rankName,
  rankMark,
  rankColor,
  dataFormat,
  dataFormatYyyyMm
} from '../utils/StampUtil.js'
import StampHistoryTitle from './StampHistory/YearlyRankTitle'
import { FactoryTrack } from '@/constant/firebase'

// 前月 前々月名計算用ファンクションエイリアス
const monthStr = i => {
  return moment()
    .subtract(i, 'months')
    .format('YYYYMM')
}

export default {
  name: 'StampHistory',
  components: {
    UIButton,
    StampHistoryTitle
  },
  data: function() {
    return {
      mounted: false,
      rankUp: false,
      rankMsg: ''
    }
  },
  computed: {
    ...mapGetters({
      ranks: 'Stamp/ranks',
      rankings: 'Stamp/rankings',
      stamp_total: 'Stamp/stamp_total',
      histories: 'Stamp/histories',
      user_type: 'Stamp/user_type',
      user_create_at: 'Stamp/user_create_at'
    }),
    lastMonth: function() {
      return (
        this.rankings.find(item => item.month === monthStr(1)) || {
          month: '',
          stamp_total: '0',
          ranking: '-'
        }
      )
    },
    pastHistories: function() {
      return this.histories || []
    }
  },
  created() {
    document.title = 'スタンプ獲得履歴'

    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.fetchStampHistory(json.app_token, accTime, json.user_id)
        window.receivedToken = null
      }
      // クーポン一覧と同じなので一旦apiTypeを3に設定する
      this.actionRequestToken({
        apiType: '3',
        acc_time: accTime
      })
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('Stamp', ['actionFetchStampHistory']),
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Native', ['actionRequestToken']),
    ...mapActions('Loading', ['actionToggleLoading']),
    sumStampCount,
    rankName,
    rankMark,
    rankColor,
    dataFormat,
    dataFormatYyyyMm,
    trapTrackEvent(id) {
      switch (id) {
        case 1:
          this.trackEvent(FactoryTrack.createStampHistoryMonthly())
          break
      }
    },
    async fetchStampHistory(token, accTime, userId) {
      try {
        this.actionToggleLoading(true)
        await this.actionFetchStampHistory({
          token: token,
          accTime: accTime,
          userId: userId
        })

        const rankingSize = this.rankings.length
        if (rankingSize === 0) {
          this.rankMsg =
            'ランキング対象外です。<br>来月からランキング表示されます。'
        } else if (rankingSize === 1) {
          this.rankMsg = '＼ はじめてのランキングです／'
        } else {
          // ランクメッセージの設定
          // ランク情報が取れない場合は強制的に大きなランクにする
          const m1 = this.rankings.find(item => item.month === monthStr(1))
          const m2 = this.rankings.find(item => item.month === monthStr(2))
          const lastRank = m1 ? Number(m1.ranking) : 99999999
          const beforeRank = m2 ? Number(m2.ranking) : 99999999

          // 前月 前々月のランクを比較してそれぞれのメッセージを設定
          if (beforeRank === lastRank) {
            this.rankUp = false
            this.rankMsg = '前月からランキングを維持しています。'
          } else if (beforeRank > lastRank) {
            this.rankUp = true
            this.rankMsg = '前月よりランキングがアップしました！'
          }
        }
        this.mounted = true
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.errorCode = e.code
        this.isError = true
        console.error(e)
      }
      this.actionToggleLoading(false)
    },
    watchStamps: function(idx) {
      this.trackEvent(FactoryTrack.createStampHistoryCard(idx))
      this.$router.push(`/stamphistory/card/${idx}`)
    },
    goBack: function() {
      this.$router.push({
        name: 'FAQ'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.l_stamp_history {
  width: 100%;
  min-height: 100%;
  background-color: #f6f1db;

  .content {
    background-color: var(--background-color);
    text-align: left;

    .link {
      width: 100%;
      text-align: right;
      margin: 20px 0;

      a {
        color: #662b12;
        font-weight: bold;
        text-decoration: none;
      }
    }

    .premium {
      display: flex;
      width: 100%;
      background: url('~@/assets/img/stampHistory/RIREKI_BAR.png');
      background-size: 100% 100%;
      // background-color: #c0a417;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 4vw;
      font-weight: bold;
      height: 14vw;

      .mark {
        height: 100%;
        padding: 0 10px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          height: 40%;
        }
      }
    }

    .rankingmsg {
      display: flex;
      width: 100%;
      background-color: #F8B616;
      background-size: 100% 100%;
      // background-color: #c0a417;
      text-align: center;
      justify-content: center;
      align-items: center;
      font-size: 4vw;
      font-weight: bold;
      height: 14vw;

      color: #fff;
      &.up {
        background-color: #ff7f78;
        color: #ffffff;
      }
    }
    h2 {
      display: flex;
      width: 100%;
      background-color: #602209;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 4vw;
      font-weight: bold;
      height: 14vw;
    }

    .summary {
      padding: 0 10px;
      border-radius: 5px;
      overflow: hidden;

      .item {
        margin: 10px 0;
        padding: 5px 20px;
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
        font-size: 12px;
        font-weight: bold;
        height: 100px;
        border-radius: 5px;
        overflow: hidden;

        .title {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          padding: 10px;

          img {
            height: 100%;
          }

          div {
            font-size: 16px;
            position: absolute;
            text-align: center;
          }
        }

        .result {
          flex: 1;
          color:#BA2121;
          text-align: right;
          font-size: 20px;

          .strong {
            font-size: 28px;
          }
        }
      }
    }

    .ranks {
      padding: 0 10px 0 10px;

      .rank {
        margin: 10px 0;
        border-radius: 5px;
        overflow: hidden;

        .header {
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: center;
          background-color: #deaa03;
          color: #ffffff;
          font-size: 4vw;
          font-weight: bold;
          height: 40px;
        }

        .body {
          background-color: #ffffff;
          display: flex;
          flex-direction: column;
          width: 100%;
          justify-content: space-evenly;
          align-items: center;

          .button {
            margin: 20px 0;
            width: 200px;
            height: 40px;

            button {
              background-color: white;
              border: 1px solid #794631;
              color: #794631;
            }
          }
        }
      }
    }
  }

  .caption {
    text-align: left;
    width: 100%;

    &.right {
      text-align: right;
    }

    margin: 8px 0px;
    padding: 4px;
    font-size: 3vw;
    color: rgb(102, 102, 102);
  }
}
</style>
